import { render, staticRenderFns } from "./orderRemarks.vue?vue&type=template&id=9eed1ecc&scoped=true&"
import script from "./orderRemarks.vue?vue&type=script&lang=js&"
export * from "./orderRemarks.vue?vue&type=script&lang=js&"
import style0 from "./orderRemarks.vue?vue&type=style&index=0&id=9eed1ecc&prod&lang=less&scoped=true&"
import style1 from "./orderRemarks.vue?vue&type=style&index=1&id=9eed1ecc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eed1ecc",
  null
  
)

export default component.exports